import { faCheck, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import React from "react";
import ReactTable from "react-table";
import { Col, Container, Row } from "reactstrap";
import BaseButtonWithIconAndTooltip from "../../../../../toolkit/baseButtonWithIconAndTooltip";
import { userHasPermission } from "../../../../../utils/accessTree";
import { handleRequestError } from "../../../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../../../utils/notifications";
import permissionCodes from "../../../../../utils/permissionCodes";
import { deleteDiscountCode } from "../../../../actions/partners";
import ConfirmModal from "../../../../components/common/confirmModal/confirmModal";
import MexicanCurrency from "../../../common/currency";

interface Props {
  discountCodesList: object[];
  partnerMembershipId: String;
  invalidateStateValue: (fieldName: string, value: any) => void;
  getMembershipDiscountCodes: () => void;
}

class DiscountCodesTable extends React.Component<Props> {
  state = {
    confirmDeleteDiscountCodeModalIsOpen: false,
    idDiscountCodeToDelete: null,
    discountCodes: null
  };
  columns = [
    {
      Header: "Producto aplicable",
      accessor: "codigoProducto"
    },
    {
      Header: "Club aplicable",
      accessor: "codigoClubNombre"
    },
    {
      Header: "Estatus",
      accessor: "codigoEstatus"
    },
    {
      Header: "Inicio vigencia",
      accessor: "codigoInicioVigencia",
      className: "text-center",
      Cell: ({ value }) => moment(value).format("DD-MM-YYYY")
    },
    {
      Header: "Fin vigencia",
      accessor: "codigoFinVigencia",
      className: "text-center",
      Cell: ({ value }) => moment(value).format("DD-MM-YYYY")
    },
    {
      Header: "Código",
      accessor: "codigoDescuento",
      className: "text-center"
    },
    {
      Header: "Tipo",
      accessor: "codigoTipoDescuento",
      className: "text-center"
    },
    {
      Header: "Descuento",
      accessor: "descuento",
      className: "text-center",
      Cell: row => {
        return row.original.codigoTipoDescuento == "PORCENTAJE" ? (
          <span> {row.original.codigoPorcentajeDescuento} % </span>
        ) : row.original.codigoTipoDescuento == "MONTO" ? (
          <MexicanCurrency quantity={row.original.codigoMontoDescuento} />
        ) : null;
      }
    },
    {
      Header: () => (
        <div className="w-100 text-center">
          <BaseButtonWithIconAndTooltip
            id={`discountCodesCheckAll_`}
            icon={faCheck}
            tooltipTitle={"Seleccionar todos"}
            onClick={() => {
              this.handleDiscountCodeCheckAll(true);
            }}
          />
          {"   "}
          <BaseButtonWithIconAndTooltip
            id={`discountCodesUnCheckAll_`}
            icon={faTimes}
            tooltipTitle={"Deseleccionar todos"}
            onClick={() => {
              this.handleDiscountCodeCheckAll(false);
            }}
          />

          {"      "}
          <BaseButtonWithIconAndTooltip
            id={`discountCodesDeleteAll_`}
            icon={faTrash}
            tooltipTitle={"Eliminar seleccionados"}
            onClick={() => {
              this.setState({
                confirmDeleteDiscountCodeModalIsOpen: true
              });
            }}
          />
        </div>
      ),
      Cell: row => {
        return userHasPermission(
          permissionCodes.PARTNER_MEMBERSHIP_TAB_DISCOUNT_CODES_DELETE_DISCOUNT_CODE
        ) && row.original.codigoEstatus == "CREADO" ? (
          <div>
            {" "}
            {/* <BaseButtonWithIconAndTooltip
              id={`deleteFreeGuestsAccess_${row.original.id}`}
              icon={faTimes}
              tooltipTitle={"Eliminar código de descuento"}
              onClick={() => {
                this.setState({
                  idDiscountCodeToDelete: row.original.id,
                  confirmDeleteDiscountCodeModalIsOpen: true
                });
              }}
            /> */}{" "}
            <input
              type="checkbox"
              checked={row.original.checked}
              onChange={e =>
                this.handleDiscountCodeCheck(row.original.id, e.target.checked)
              }
              style={{ marginLeft: "0.75rem" }}
            />
          </div>
        ) : null;
      }
    }
  ];

  componentDidUpdate(prevProps) {
    const prevLength = (prevProps.discountCodesList || []).length;
    const currentLength = (this.props.discountCodesList || []).length;

    if (prevLength != currentLength && currentLength > 0) {
      if ((this.state.discountCodes || []).length <= 0) {
        const dc = [
          ...(this.props.discountCodesList || []).map(x => {
            return { ...x, checked: false };
          })
        ];
        this.setState({ discountCodes: dc });
      }
    }
  }

  handleFreeGuestsAccessDelete = () => {
    const { partnerMembershipId: idMembresiaSocio } = this.props;
    const dcToDelete = this.state.discountCodes.filter(x => !!x.checked);

    if ((dcToDelete || []).length <= 0) {
      return;
    }

    infoNotification("Eliminando códigos de descuento seleccionados...");

    Promise.all(dcToDelete.map(x => deleteDiscountCode(idMembresiaSocio, x.id)))
      .then(async () => {
        successNotification("Códigos de descuento eliminados correctamente...");

        await this.setState({
          idDiscountCodeToDelete: null,
          confirmDeleteDiscountCodeModalIsOpen: false,
          discountCodes: null
        });

        this.props.invalidateStateValue("discountCodes", []);
        this.props.getMembershipDiscountCodes();
      })
      .catch(handleRequestError);
  };

  getDiscountCodes = () => {
    return [...(this.state.discountCodes || [])];

    /* if ((this.props.discountCodesList || []).length <= 0) {
      return [];
    }

    if ((this.state.discountCodes || []).length <= 0) {
      const dc = [...(this.props.discountCodesList || []).map(x => {
        return { ...x, checked: false }
      })]
      this.setState({ discountCodes: dc });
      return dc;
    } else {
      return [... (this.state.discountCodes || [])];
    } */
  };

  handleDiscountCodeCheck = (dcId, checked) => {
    const { discountCodes } = this.state;
    (discountCodes || []).forEach(x => {
      if (x.id == dcId) {
        x.checked = checked;
      }
    });
    this.setState({ discountCodes });

    console.info((discountCodes || []).filter(x => !!x.checked));
  };

  handleDiscountCodeCheckAll = checked => {
    const { discountCodes } = this.state;
    (discountCodes || []).forEach(x => {
      x.checked = checked;
    });
    this.setState({ discountCodes });
    console.info((discountCodes || []).filter(x => !!x.checked));
  };

  render() {
    return (
      <Container className="p-0">
        <ConfirmModal
          title="Eliminar código de descuento"
          message="Se eliminaran los códigos de descuento seleccionados, ¿Desea continuar?"
          isOpen={this.state.confirmDeleteDiscountCodeModalIsOpen}
          requireInput={false}
          ok={this.handleFreeGuestsAccessDelete}
          cancel={() => {
            this.setState({
              idDiscountCodeToDelete: null,
              confirmDeleteDiscountCodeModalIsOpen: false
            });
          }}
        />
        <Row>
          <Col>
            <ReactTable
              data={this.getDiscountCodes()}
              columns={this.columns}
              pageSize={20}
              showPagination={true}
              className="mt-3"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default DiscountCodesTable;
